import React from 'react';
import { Star } from 'lucide-react';
import Marquee from 'react-fast-marquee';

const reviews = [
  { author: 'Thomas L.', text: 'Excellent garage, travail soigné et prix très correct. Je recommande vivement !', rating: 5 },
  { author: 'Sophie M.', text: 'Très professionnels. Mon véhicule a été réparé rapidement et efficacement.', rating: 5 },
  { author: 'Jean-Pierre D.', text: 'Accueil chaleureux et conseils avisés pour l\'achat de mon véhicule d\'occasion.', rating: 5 },
  { author: 'Marie C.', text: 'Service impeccable. Diagnostic précis et réparation dans les délais annoncés.', rating: 5 },
  { author: 'Karim B.', text: 'Un garage de confiance. Prix honnêtes et travail de qualité. MCA CAR au top !', rating: 5 },
  { author: 'Nathalie R.', text: 'Toujours satisfaite de leurs prestations. Équipe sympathique et compétente.', rating: 5 },
  { author: 'Lucas P.', text: 'Merci pour votre réactivité ! Ma voiture roule comme neuve après la réparation.', rating: 5 },
  { author: 'Isabelle F.', text: 'Garage sérieux et professionnel. Je les recommande les yeux fermés.', rating: 5 },
  { author: 'Bruno G.', text: 'Très bon rapport qualité/prix. Véhicule d\'occasion acheté en toute confiance.', rating: 5 },
  { author: 'Élodie V.', text: 'Service client au top. Ils prennent le temps d\'expliquer les interventions.', rating: 4 },
];

function ReviewCard({ review }) {
  return (
    <div className="glass-card p-5 mx-3 w-[300px] flex-shrink-0">
      <div className="flex gap-0.5 mb-3">
        {[...Array(review.rating)].map((_, i) => (
          <Star key={i} size={14} className="text-yellow-500 fill-yellow-500" />
        ))}
      </div>
      <p className="text-zinc-400 text-sm leading-relaxed mb-4">"{review.text}"</p>
      <p className="text-white text-sm font-semibold">{review.author}</p>
    </div>
  );
}

export default function ReviewsBanner() {
  return (
    <section className="py-16 lg:py-20 overflow-hidden" style={{ background: 'var(--bg-primary)' }} data-testid="reviews-section">
      <div className="max-w-7xl mx-auto px-4 mb-10">
        <span className="section-label">Témoignages</span>
        <h2 className="text-3xl sm:text-4xl font-extrabold text-white mt-3 tracking-tight">
          Ce que disent nos clients
        </h2>
        <p className="text-zinc-500 mt-2">Note moyenne de 4.9/5 sur Google</p>
      </div>

      <Marquee speed={30} gradient={false} pauseOnHover>
        {reviews.map((review, i) => (
          <ReviewCard key={i} review={review} />
        ))}
      </Marquee>
    </section>
  );
}
